module.exports = __webpack_public_path__ + "img/bebe.a986d6cc.png";